import { render, staticRenderFns } from "./Icon3.vue?vue&type=template&id=bf41a672"
import script from "./Icon3.vue?vue&type=script&lang=js"
export * from "./Icon3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports